import { render, staticRenderFns } from "./DeleteInvestorsModal.vue?vue&type=template&id=efee9c16&scoped=true"
import script from "./DeleteInvestorsModal.vue?vue&type=script&lang=js"
export * from "./DeleteInvestorsModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteInvestorsModal.vue?vue&type=style&index=0&id=efee9c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efee9c16",
  null
  
)

export default component.exports